import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSettings() {
      return new Promise((resolve, reject) => {
        axios
          .get('/document-validation-settings')
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
    updateSetting(ctx, {
      documentType, enabled, provider_order, on_unavailable,
    }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/document-validation-settings/${documentType}`, { enabled, provider_order, on_unavailable })
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
  },
}
